import React from 'react'
import { IsSpecialEmployer } from 'application/helpers'

function NonInsuranceDisclaimer() {
  let isSAGBYO = IsSpecialEmployer("SAGBYO")

  let ThingsYouNTK = isSAGBYO ? "This general information doesn't take your personal circumstances into account. Please consider whether this information is right for you before making a decision and seek professional independent tax or financial advice. Conditions and fees apply, along with credit assessment criteria for lease products. This availability of benefits is subject to your employer's approval. Maxxia may pay and/or receive commissions in connection with its services.": "This general information doesn't take your personal circumstances into account. Please read the PDS and consider whether this information is right for you before making a decision and seek professional independent tax or financial advice. Conditions and fees apply, along with credit assessment criteria for lease and loan products. This availability of benefits is subject to your employer's approval. Maxxia may receive commissions in connection with its services."

  return global.config.isBrandMX ? (
    <div>
      <p className="text-smaller">
        Maxxia Pty Ltd | ABN 39 082 449 036 act as an authorised representative
        on behalf of a number of Australian financial services licensees. The
        capacity in which we act and the financial services we are authorised to
        provide are set out in our{' '}
        <strong>
          <a
            href="https://www.maxxia.com.au/insurance/novated-lease#fsgs"
            className="text-dark text-underline"
            target="_blank"
            rel="noopener noreferrer"
            id="noninsurancedisclaimer.fsglink"
          >
            Financial Services Guides
          </a>
        </strong>
        . We act as an agent for those licensees and not for you.
      </p>
      <p className="text-smaller">
        <b className="text-dark">Things you need to know:</b> {ThingsYouNTK}
      </p>
      <p className="text-smaller">
        Maxxia collects your personal information from you when you apply for a
        product and request any information from us, and we may use this
        information to contact you about our products, services and offerings.
        To read more about how we handle your personal information, please read
        our{' '}
        <a
          href="https://mmsg.com.au/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark text-underline font-weight-bold"
          id="noninsurancedisclaimer.privacystatement"
        >
          Privacy Statement
        </a>
        .
      </p>
    </div>
  ) : (
    <p>
      Remuneration Services (QLD) Pty Ltd (ABN 46 093 173 089) (RemServ) act as
      an authorised representative on behalf of a number of Australian financial
      services licensees. The capacity in which we act and the financial
      services we are authorised to provide are set out in our{' '}
      <a
        href="https://www.remserv.com.au/insurance/novated-lease#fsgs"
        className=""
        target="_blank"
        rel="noopener noreferrer"
      >
        Financial Services Guides
      </a>
      . We act as an agent for those licensees and not for you.
    </p>
  )
}

export default NonInsuranceDisclaimer
